export default __webpack_public_path__ + "static/media/covid.8ad205b8.png";